/**
 * Dependent on mattress-hybrid-option.js, which is a global script
 * added to all mattress pages with hybrid foam options.
 */

 class MatFullSpecsHE {
  constructor(sectionEl) {
    this.sectionEl = sectionEl;
    if (!this.sectionEl) {
      return;
    }

    this.cacheJSONs();
    this.cacheDynamicEls();

    this.attachListeners();
  }

  cacheJSONs() {
    this.foamSectionSettings = JSON.parse(
      this.sectionEl.querySelector(
        '[data-foam-section-settings="mattress-full-specs"]'
      ).innerHTML
    );
    this.foamBlockSettings = JSON.parse(
      this.sectionEl.querySelector(
        '[data-foam-block-settings="mattress-full-specs"]'
      ).innerHTML
    );

    // Get JSON info from the hybrid expansion pack section
    this.hybridSectionSettings = JSON.parse(
      document.querySelector(
        '[data-hybrid-section-settings="mattress-full-specs"]'
      ).innerHTML
    );
    this.hybridBlockSettings = JSON.parse(
      document.querySelector(
        '[data-hybrid-block-settings="mattress-full-specs"]'
      ).innerHTML
    );
  }

  cacheDynamicEls() {
    this.titleEl = this.sectionEl.querySelector(
      '.MFSFullDetails__MainHeading'
    );
    this.dimensionsWrapper = this.sectionEl.querySelector(
      '.MFSDimensionsArea .swiper-wrapper'
    );
    this.constructionWrapper = this.sectionEl.querySelector(
      '.MFSConstructionSwiper .swiper-wrapper'
    );
    this.shippingSlidesWrapper = this.sectionEl.querySelector(
      '.MFSShippingSwiper .swiper-wrapper'
    );
  }

  attachListeners() {
    // Toggle the hybrid toggle when the product is changed
    document.addEventListener('state:option-changed', e => {
      if (e && e.detail && e.detail.productJSONChanged) {
        const value = window.HybridUpsellState.selectedValue;
        this.updateDOM(value);
      }
    });
  }

  /**
   * Updates the DOM to the chosen value (hybrid foam/foam) when selected.
   */
  async updateDOM(value) {
    const blockSettings =
      value === 'foam' ? this.foamBlockSettings : this.hybridBlockSettings;
    const sectionSettings =
      value === 'foam' ? this.foamSectionSettings : this.hybridSectionSettings;

    // Hide area for a brief moment (just to smoothen the load)
    // await this.fadeOutAndWait([this.innerContainer], 350);

    this.updateSlides(sectionSettings);

    // Reinitialize the entire section's code
    this.sectionEl.instance.updateSwipersAndHeight();

    // await this.waitAndfadeIn([this.innerContainer], 100);
  }

  updateSlides(settings) {
    this.updateTitle(settings);
    this.updateDimensions(settings);
    this.updateConstructionSlides(settings);
    this.updateShippingSlides(settings);
  }

  updateTitle(settings) {
    this.titleEl.innerHTML = settings.full_specs_heading;
  }

  updateDimensions(settings) {
    let resultHTML = '';
    const dimensionsList = settings.dimensions_list.split('==');
    dimensionsList.forEach(dimensionParts => {
      try {
        const [sizeName, dimensions, weight] = dimensionParts.split('|');
        resultHTML += `
          <article class="MFSDimensionsArea__Item swiper-slide">
            <h4 class="MFSDimensionsArea__ItemName">
              ${sizeName}
            </h4>
            <p class="MFSDimensionsArea__Label">
              Dimensions:
            </p>
            <p class="MFSDimensionsArea__Value">
              ${dimensions}
            </p>
            ${
              weight && `
                <p class="MFSDimensionsArea__Label">
                  Weight:
                </p>
                <p class="MFSDimensionsArea__Value">
                  ${weight}
                </p>
              `
            }
          </article>
        `;
      } catch(err) {
        console.error(err, 'Incorrect settings for full spec dimensions.');
      }
    });

    this.dimensionsWrapper.innerHTML = resultHTML;
  }

  updateConstructionSlides(settings) {
    let resultHTML = '';
    for (let i = 1; i < 3; i++) {
      const titleKey = `constr_title_${i}`;
      const htmlKey = `constr_html_${i}`;
      resultHTML += `
        <article class="swiper-slide MFSConstructionSwiper__Slide">
          <h4 class="MFSConstructionSwiper__Heading">
            ${settings[titleKey]}
          </h4>
          <div class="MFSConstructionSwiper__Contents">
            ${settings[htmlKey]}
          </div>
        </article>
      `;
    }

    this.constructionWrapper.innerHTML = resultHTML;
  }
  
  updateShippingSlides(settings) {
    let resultHTML = '';
    for (let i = 1; i < 4; i++) {
      const htmlKey = `shipping_html_${i}`;
      resultHTML += `
        <article class="swiper-slide MFSShippingSwiper__Slide">
          <div class="MFSShippingSwiper__Contents">
            ${settings[htmlKey]}
          </div>
        </article>
      `;
    }

    this.shippingSlidesWrapper.innerHTML = resultHTML;
  }

  /**
   * Fade in and out, resolving promise after giving chance for the fade out to
   * visually complete.
   * TODO: Place in NUtils for its versatility.
   */
  async fadeOutAndWait(elements, ms) {
    elements.forEach(e => (e.style.opacity = '0'));

    return new Promise(resolve => {
      if (this.fadeAnimationHandle) {
        clearTimeout(this.fadeAnimationHandle);
      }
      this.fadeAnimationHandle = setTimeout(() => {
        resolve();
      }, ms);
    });
  }

  async waitAndfadeIn(elements, ms) {
    return new Promise(resolve => {
      if (this.fadeAnimationHandle) {
        clearTimeout(this.fadeAnimationHandle);
      }
      this.fadeAnimationHandle = setTimeout(() => {
        elements.forEach(e => (e.style.opacity = '1'));
        this.fadeAnimationHandle = null;
        resolve();
      }, ms);
    });
  }

}

/**
 * Initialize the hybrid expansion pack. Assumes there is only one.
 */
(function () {
  const sectionEl = document.querySelector('.MattressFullSpecs');
  window.dMFS = new MatFullSpecsHE(sectionEl);
})();
